(function (TIPTOE, Flickity, d) {
  const tabLabels = document.querySelectorAll('.js-tab');
  const tabsTables = Array.from(document.querySelectorAll('.tabs-table'));

  /**
   * Sets a clicked tab to active state
   * @param {event} evt The click event on the tab
   */
  function setActiveTab(evt) {
    let i;
    let j;
    let k;
    let tabContentPanes;
    let clickedTab;
    let associatedTabContent;

    clickedTab = evt.currentTarget;
    const associatedTabContentId = clickedTab.dataset.tabId;
    const mainParent = clickedTab.parentElement.parentElement.parentElement;
    const sliderProductContainer = mainParent.querySelector('.sliderproducts-container');
    const currentTabLabels = mainParent.querySelectorAll('.js-tab');

    if (tabsTables.length >= 1) {
      const groupContentId =
        clickedTab.parentElement.parentElement.dataset.postId !== undefined
          ? clickedTab.parentElement.parentElement.dataset.postId
          : clickedTab.closest('.tabs-table').dataset.postId;
      const parentElement = document.querySelector(`.tabs-table[data-post-id="${groupContentId}"]`);
      tabContentPanes = parentElement.querySelectorAll('.js-tab-content');

      for (i = 0; i < tabContentPanes.length; i++) {
        tabContentPanes[i].classList.remove('is-active');
      }

      associatedTabContent = parentElement.querySelector(
        `[data-tab-content-id="${associatedTabContentId}"]`,
      );
    } else {
      tabContentPanes = sliderProductContainer.querySelectorAll('.js-tab-content');

      for (i = 0; i < tabContentPanes.length; i++) {
        tabContentPanes[i].classList.remove('is-active');
      }

      associatedTabContent = Array.from(tabContentPanes).find(function (tabContent) {
        return tabContent.dataset.tabContentId === associatedTabContentId;
      });
    }

    associatedTabContent.classList.add('is-active');

    for (k = 0; k < currentTabLabels.length; k++) {
      currentTabLabels[k].classList.remove('is-active');
    }

    clickedTab.classList.add('is-active');
    evt.preventDefault();

    TIPTOE.lazy.revalidate();

    if (typeof Flickity !== 'undefined') {
      const flickities = associatedTabContent.querySelectorAll('.flickity-enabled');

      for (j = 0; j < flickities.length; j++) {
        const flickity = new Flickity(flickities[j]);
        flickity.resize();
      }
    }
  }

  for (const tabLabel of tabLabels) {
    tabLabel.addEventListener('click', setActiveTab);
  }
})(TIPTOE, Flickity, document);
